<template>
    <li class="tree-li">
        <div class="acct-node">
            <div class="acct-accent"></div>
            <div class="acct-body">
                <div class="acct-avatar-row">
                    <div class="acct-ini">{{ initials }}</div>
                </div>
                <div class="acct-title">{{ roleTitle }}</div>
                <div class="acct-name">{{ node.Name }}</div>
                <div v-if="node.Team" class="acct-team-row">
                    <span class="pill" :class="teamColorClass">{{ node.Team }}</span>
                </div>
                <div v-if="accountabilities.length" class="acct-resp">
                    <div class="acct-resp-label">Roles and Responsibilities</div>
                    <ul>
                        <li v-for="(a, i) in accountabilities" :key="i"><span class="acct-dot"></span><span>{{ a.value }}</span></li>
                    </ul>
                </div>
            </div>
            <button v-if="accountabilities.length" type="button" class="acct-detail-btn" @click="showRoleCol()">
                <span>Role Sheet</span><span class="acct-detail-arrow">&rarr;</span>
            </button>
        </div>
        <ul v-if="node.children && node.children.length" class="tree-ul">
            <accountability-chart-node v-for="c in node.children" :key="c.EmployeeID" :node="c" />
        </ul>
    </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { findSeat, seatAccountabilities, seatTitle } from '@/roleSheet';
import { NodeRange } from '@tiptap/pm/model';

export default defineComponent({
    name: 'AccountabilityChartNode',
    props: {
        node: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            accountabilities: [] as any
        }
    },
    computed: {
        // From their seat on the role sheet, not the employee record's job title
        roleTitle(): string {
            return seatTitle(this.$store.state.allNodes, this.node.RoleSheetSlug, this.node.RoleSheetColID);
        },
        initials(): string {
            if(!this.node.Name) {
                return '';
            }
            const parts = this.node.Name.trim().split(/\s+/);
            if(parts.length == 1) {
                return parts[0].substring(0, 2).toUpperCase();
            }
            return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
        },
        teamColorClass(): string {
            if(!this.node.Team) {
                return '';
            }
            // color by the team's position in the configured teams list (Configuration > Employee
            // Teams), cycling through the 6 pill colors -- not a hash, so colors stay visually
            // grouped in list order and only repeat once there are more than 6 teams
            const idx = this.$store.state.employeeTeams.indexOf(this.node.Team);
            return `t-team-${idx > -1 ? idx % 6 : 0}`;
        }
    },
    watch: {
        node: {
            immediate: true,
            handler() {
                this.loadAccountabilities();
            }
        }
    },
    methods: {
        loadAccountabilities() {
            const found = findSeat(this.$store.state.allNodes, this.node.RoleSheetSlug, this.node.RoleSheetColID);
            this.accountabilities = found ? seatAccountabilities(found.seat) : [];
        },
        showRoleCol() {
            this.$store.state.RoleSheetSlug = this.node.RoleSheetSlug;
            this.$store.state.RoleSheetColID = this.node.RoleSheetColID;
            this.$store.state.showRoleCol = true;
        }
    }
});
</script>
